import { useState, useEffect, useCallback } from "react"

export const useLocalStorage = <T>(key: string, defaultValue: T) => {
	// Initialize state with a function to avoid hydration mismatches
	const [value, setValue] = useState<T>(() => {
		if (typeof window === "undefined") {
			return defaultValue
		}

		try {
			const stored = localStorage.getItem(key)
			if (stored) {
				return JSON.parse(stored)
			}
		} catch (e) {
			console.error("Error parsing localStorage:", e)
		}

		return defaultValue
	})

	// Update localStorage whenever value changes (client-side only)
	useEffect(() => {
		if (typeof window !== "undefined") {
			try {
				localStorage.setItem(key, JSON.stringify(value))
			} catch (e) {
				console.error("Error saving to localStorage:", e)
			}
		}
	}, [key, value])

	const setStoredValue = useCallback((newValue: T) => {
		setValue(newValue)
	}, [])

	return [value, setStoredValue] as const
}
